import PostHogProvider from "@shared/providers/PostHogProvider";
import { ReactNode } from "react";
import { Link } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

export default function AppLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();

  return (
    <PostHogProvider>
      <s-app-nav>
        {/* Why not use s-link? I don't know, it doesn't work */}
        <Link href="/app" rel="home">
          {t("NavigationMenu.home")}
        </Link>
        <Link href="/app/settings">
          {t("NavigationMenu.settings")}
        </Link>
      </s-app-nav>
      {children}
    </PostHogProvider>
  );
}
